import React from "react";
import Dialog from "@material-ui/core/Dialog";
import { DialogTitle } from "../components/DialogTitle";
import { DialogContent } from "../components/DialogContent";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { TextInput } from "../components/TextInput";
import { TextLabel } from "../components/TextLabel";
import { FileInput } from "../components/FileInput";
import { Chips } from "../components/Chips";
import { ChipsType } from "../components/ChipsType";
import { allVrTypes } from "../utils/vrTypes";
import SelectOrganization from "../containers/SelectOrganization";
import { GlobalAccessCheckbox } from "../components/GlobalAccessCheckbox";
import { stringList } from "../utils/stringUtils";

export const EditManagedAppDialog = ({
  dialogTitle,
  app,
  onClose,
  onSave,
  saveAvaliable,
  title,
  onTitleChange,
  vrTypes,
  onVrTypesChange,
  categories,
  onCategoriesChange,
  sortPriority,
  onSortPriorityChange,
  description,
  onDescriptionChange,
  iconName,
  onIconFileChange,
  obbUrls,
  organizationKey,
  onOrganizationChange,
  globalAccess,
  onGlobalAccessChange
}) => (
    <Dialog maxWidth="lg" scroll="body" onClose={onClose} open>
      <DialogTitle
        onCancel={onClose}
        onSave={onSave}
        saveAvaliable={saveAvaliable}
      >
        {dialogTitle}
      </DialogTitle>
      <DialogContent>
        <Typography variant="caption">*Required Inputs</Typography>
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <TextInput
              label="Title"
              value={title}
              onChange={onTitleChange}
              required
            />
            <TextLabel label="Package Name" value={app.packageName} />
            <TextLabel label="VersionNumber" value={app.latestVersion} />
            <TextLabel label="Version Name" value={app.versionName} />
            <br />
            <br />
            <ChipsType
              title="Categories"
              data={categories}
              onChange={onCategoriesChange}
            />
            <TextInput
              label="Sort Priority"
              value={sortPriority}
              onChange={onSortPriorityChange}
              onFocus={event => event.target.select()}
            />
          </Grid>
          <Grid item xs={6}>
            <Typography variant="caption" display="block" gutterBottom>
              Icon *
          </Typography>
            {!iconName && <img src={app.iconUrl} style={{ width: 100 }} />}
            <br />
            <FileInput
              id="icon-button-file"
              accept=".png"
              onChange={onIconFileChange}
            >
              New Icon Image
          </FileInput>
            {iconName}
            <br /><br /><br />
            <Typography variant="caption" display="block" gutterBottom>
              {obbUrls && obbUrls.length > 0 ? `OBB: main.${app.latestVersion}.${app.packageName}.obb` : ""}
            </Typography>

          </Grid>
          <Grid item xs={12}>
            <TextInput
              label="Description"
              value={description}
              onChange={onDescriptionChange}
              multiline
            />
            <br />
            <br />
            <SelectOrganization
              value={organizationKey}
              onChange={onOrganizationChange}
            />
            <br />
            <GlobalAccessCheckbox
              value={globalAccess}
              onChange={onGlobalAccessChange}
            />
          </Grid>
        </Grid>
        <br />
      </DialogContent>
    </Dialog>
  );
